export default __webpack_public_path__ + "static/media/calendar_white.af3b8f0f.png";